module.exports = __webpack_public_path__ + "img/乐途_03.e30e8b11.jpg";